import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { Button } from '@material-ui/core';
import { useNavButtonStyles } from './ConsentDocumentBody';

export const Logout = () => {

    const navButtonClasses = useNavButtonStyles();
    const [loggedOut, setLoggedOut] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        if (!localStorage.getItem("token")) {// localStorage.getItem used to get token key value
            setLoggedOut(true);// condition true huda this function is called
        }
    }

    if (loggedOut) {
        return <Redirect to="/" />;
    }

    return (
        <Button
            color="secondary"
            fullWidth={false}
            className={navButtonClasses.navButton}
            onClick={handleLogout}>
            Logga ut
        </Button>
    );
}